import React, { useState } from 'react';
import Dialog from 'src/components/common/Dialog.redesign';
import Owner from 'src/models/tract_detail/Owner';
import WIOwnership from '../../../../../models/tract_detail/WIOwnership';
import _ from 'lodash';
import Button from 'src/components/controls/forms/redesign/FormButton';
import { IRootState } from 'src/reducers';
import { useSelector } from 'react-redux';
import { Url } from 'src/api';
import useFetch from 'use-http';
// import CheckboxBase from 'src/components/controls/forms/base/CheckboxBase';
import Checkbox from 'src/components/controls/forms/Checkbox';

interface IDeleteORRIDialogProps {
    workingInterestId: number;
    workingInterestName: string;
    orriList: WIOwnership[];
    ownerList: Owner[];
    onComplete: () => void;
    onCloseDialog?: () => void;
}

const ORRIRow: React.FC<{ orri: WIOwnership; owner: Owner; checked: boolean; toggle: (id: number) => void }> = ({ orri, owner, checked, toggle }) => {
    return (
        <div>
            <Checkbox
                value={checked}
                onChange={() => toggle(orri.id)}
                label={`${owner.name} (${owner.ownerType}) with ${orri.decimalInterest} interest`}
            />
        </div>
    );
};

const DeleteORRIDialog: React.FC<IDeleteORRIDialogProps> = (props) => {
    const [checkedORRI, setCheckedORRI] = useState<number[]>([]);
    const [toggleAllChecked, setToggleAllChecked] = useState(false);
    const { post, response } = useFetch();
    const appContext = useSelector((storeState: IRootState) => storeState.appContext);

    const deleteORRI = async () => {
        const body = {
            orriList: checkedORRI,
        };

        await post(
            `${Url.project.getProject(appContext, appContext.projectNumber)}\\leaseholdownerships\\${props.workingInterestId}\\delete-orri`,
            body
        );

        if (response.ok) {
            if (props.onCloseDialog) {
                props.onCloseDialog();
            }
            if (props.onComplete) {
                props.onComplete();
            }
        }
    };
    const toggle = (id: number) => {
        const list = [...checkedORRI];
        if (_.includes(list, id)) {
            _.remove(list, (x) => x === id);
        } else {
            list.push(id);
        }

        setToggleAllChecked(list.length === props.orriList.length);

        setCheckedORRI(list);
    };

    const toggleAll = () => {
        if (checkedORRI.length >= 0 && checkedORRI.length < props.orriList.length) {
            setCheckedORRI(props.orriList.map((wio: WIOwnership) => wio.id));
            setToggleAllChecked(true);
        } else {
            setCheckedORRI([]);
            setToggleAllChecked(false);
        }
    };

    return (
        <Dialog title={`Delete ORRI from ${props.workingInterestName}`}>
            <Checkbox value={toggleAllChecked} onChange={toggleAll} label="Select/Deselect All ORRI" />
            <hr />
            <div style={{ overflow: 'auto', maxHeight: '50vh' }}>
                {props.orriList.map((wio: WIOwnership) => {
                    return (
                        <ORRIRow
                            key={wio.id}
                            orri={wio}
                            owner={props.ownerList.filter((o: Owner) => o.ownerLookUpId === wio.ownerLookUpId)[0]}
                            checked={checkedORRI.findIndex((i) => i === wio.id) >= 0}
                            toggle={toggle}
                        />
                    );
                })}
            </div>
            <div style={{ textAlign: 'right', margin: '.7rem 0 .7rem 0' }}>
                <Button disabled={checkedORRI.length <= 0} type="submit" text="Delete" intent="primary" onClick={deleteORRI} />
            </div>
        </Dialog>
    );
};

export default DeleteORRIDialog;



// WEBPACK FOOTER //
// ./src/components/project/sections/TractComponents/dialogs/DeleteORRIDialog.tsx